// extracted by mini-css-extract-plugin
export default {"history":"History_history__WB8Jo","message":"History_message__uqDCZ","tbody":"History_tbody__m-RF7"};